<mat-toolbar color="secondary">
  <mc-navbar-help-button [appVersionAndBuildDate]="appVersionAndBuildDate$ | async"></mc-navbar-help-button>
</mat-toolbar>
